/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ platform: NonNullable<unknown> }} Platform_Tools_HeadingInputs */

const en_platform_tools_heading = /** @type {(inputs: Platform_Tools_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Run ${i?.platform} data in the browser`)
};

const zh_hans1_platform_tools_heading = /** @type {(inputs: Platform_Tools_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`在浏览器中获取 ${i?.platform} 数据`)
};

const pt_br2_platform_tools_heading = /** @type {(inputs: Platform_Tools_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Consulte dados de ${i?.platform} no navegador`)
};

const es_platform_tools_heading = /** @type {(inputs: Platform_Tools_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Consulta datos de ${i?.platform} en el navegador`)
};

const fr_platform_tools_heading = /** @type {(inputs: Platform_Tools_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exécutez des données ${i?.platform} dans le navigateur`)
};

const de_platform_tools_heading = /** @type {(inputs: Platform_Tools_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.platform}-Daten im Browser abrufen`)
};

const ru_platform_tools_heading = /** @type {(inputs: Platform_Tools_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Запускайте данные ${i?.platform} в браузере`)
};

const it_platform_tools_heading = /** @type {(inputs: Platform_Tools_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esegui i dati di ${i?.platform} nel browser`)
};

/**
* | output |
* | --- |
* | "Run {platform} data in the browser" |
*
* @param {Platform_Tools_HeadingInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_tools_heading = /** @type {((inputs: Platform_Tools_HeadingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Tools_HeadingInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_tools_heading(inputs)
	if (locale === "pt-BR") return pt_br2_platform_tools_heading(inputs)
	if (locale === "es") return es_platform_tools_heading(inputs)
	if (locale === "fr") return fr_platform_tools_heading(inputs)
	if (locale === "de") return de_platform_tools_heading(inputs)
	if (locale === "ru") return ru_platform_tools_heading(inputs)
	if (locale === "it") return it_platform_tools_heading(inputs)
	return en_platform_tools_heading(inputs)
});